import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../../../../services/settings.service';
import {MetodosServicio} from '../../../../_helpers/interfaces/metodos-servicio';
import {Fraccionamiento} from '../../../../_models/fraccionamiento';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FraccionamientoService extends MetodosServicio<Fraccionamiento>{

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'entidad/fraccionamiento', Fraccionamiento);
  }

  obtenerListaCreditos(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'fraccionate/entidad/solicitud/credito/list', filtro);
  }

  /**
   * Método para obtener la lista de los estaddos de solicitud de crédito
   * @returns lista de estados de solicitud de crédito
   */
  obtenerListaEstaddoSolicitudCredito(cantidad = 20) {
    return this.http.get(this.settings.URL_BASE + 'public/solicitud_credito_estado' + (cantidad ? '?cantidad=' + cantidad : ''));
  }

  /**
   * Actualiza un registro.
   * @param item Registro a ser actualizado.
   */
  modificarSolicitud(idSolicitud:number,item: any): Observable<any> {
    return this.http.put<any>(this.settings.URL_BASE + 'fraccionate/solicitud/credito/' + idSolicitud, item);
  }


  restartItem(): void {
    this.setItem(new Fraccionamiento());
  }
}
